import styled from 'styled-components';

const Wrapper = styled.div`
  background: #fff;
  width: 100%;
  // max-width: 460px;
  // min-width: 460px;
  //border: 1px solid #cdd4df;
  height: 100%;
  overflow: auto;
  position: relative;
  //padding: 16px;
`;

const Header = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 99;
`;

const StructedTableList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;

  .category-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .input-container {
    width: 131px;
    height: 24px;
    padding: 4px 3px 4px 3px;
    gap: 6px;
    border-radius: 6px;
    border: 0.5px;
    opacity: 0px;
    background: #fff;
    border: 0.5px solid #7888f5;
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      flex: 1;
      background: #3d3bff33;
      border-radius: 4px;
      outline: none;
      width: 100%;
      border: none;

      font-size: 12px;
      font-weight: 500;
      line-height: 14.56px;
      text-align: left;
    }
  }
`;

const StructedTableItem = styled.div`
  padding: 4px 8px;
  border-radius: 6px;
  background: #fff;
  color: ${({ isEmpty }) => (isEmpty ? '#ababab' : '#2b313d')};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  background: ${({ isActive }) => (isActive ? 'rgba(61, 59, 255, 0.20)' : '#fff')};
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: rgba(61, 59, 255, 0.2);
  }
  .icon-button {
    display: flex;
    width: 12px;
    align-items: center;

    height: 14px;
  }
`;

const Category = styled.div`
  width: 136px;
`;

const TableStyle = styled.div`
  overflow: auto;
  border-bottom: 1px solid #cdd4df;
  &:last-child {
    border-bottom: none;
  }
`;

const StructedTableCard = styled.div`
  padding: 8px 12px;
  //background-color: #e7f0ff;
  display: flex;
  flex-direction: column;
  gap: 5px;

  .add_field {
    cursor: pointer;
    width: 141px;
    height: 24px;
    background: #3d3bff33;
    border-radius: 6px;
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 14.56px;
    text-align: center;
    gap: 6px;
    border: none;
    outline: none;

    svg {
      path {
        stroke: #000;
      }
    }
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #cdd4df;
    margin-bottom: 8px;
    .items {
      display: flex;
      align-items: center;
      gap: 10px;
      .select-all {
        display: flex;
        align-items: center;
        gap: 4px;
        p {
          color: #2b313d;
          text-align: center;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }

  h4 {
    color: #2b313d;
    font-size: 12px;
    font-weight: 700;
    span {
      font-weight: 400;
    }
  }
`;

const FundChildrenContainer = styled.div`
  background: ${({ isActive, bgColor }) => (isActive ? bgColor : '#fff')};
`;

const FundContainer = styled.div`
  border-bottom: 1px solid #cdd4df;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'initial')};
  // pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'initial')};
  padding-bottom: 10px;

  svg,
  span,
  button,
  .radio_btn {
    pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'initial')};
    ${({ isDisabled }) =>
      isDisabled &&
      `
      cursor: normal;
    `};
  }
`;

const FundChildrenDataValues = styled.div`
  color: #2b313d;
  font-size: 12px;
  font-weight: 500;
  padding-left: 12px;
  border-top: 1px solid #cdd4df;
  /* border-right: 1px solid #cdd4df; */
  padding-left: 38px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  min-height: 15px;
  width: 100%;
  span {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  p {
    /* width: 150px; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 600;
  }
`;

const ColumnValue = styled.div`
  min-width: ${({ isMultipleItems }) => (isMultipleItems ? '200px' : 'initial')};
  max-width: ${({ isMultipleItems }) => (isMultipleItems ? '200px' : '100%')};
  display: flex;
  border-right: 1px solid #cdd4df;
  cursor: pointer;
`;
const FundChildrenData = styled.div`
  min-width: ${({ isMultipleItems }) => (isMultipleItems ? '200px' : 'initial')};
  max-width: ${({ isMultipleItems }) => (isMultipleItems ? '200px' : 'initial')};
  display: flex;
  background-color: ${({ bgColor }) => bgColor};
  border-bottom: 1px solid #cdd4df;
`;

const FundChildrenDataLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 0;
  padding-left: 38px;
  padding-right: 10px;
  border-right: 1px solid #cdd4df;
  border-top: 1px solid #cdd4df;
  width: 100%;
  justify-content: space-between;
  .label {
    gap: 6px;
    display: flex;
    align-items: center;
    width: 87%;
    p {
      font-size: 12px;
      font-weight: 600;
      color: #2b313d;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      max-width: 140px;
      line-height: 14px;
    }
  }
  .delete_btn {
    display: flex;
    cursor: pointer;
  }
`;

const TableName = styled.div`
  padding: 2px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  &:last-child {
    border: none;
  }
  padding-left: ${({ isPickedFound }) => (isPickedFound ? '24px' : '12px')};
  background: ${({ isActive, bgColor }) => (isActive ? bgColor : '#fff')};
`;

const Fund = styled.div`
  padding: 2px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cdd4df;
  cursor: pointer;
  &:last-child {
    border: none;
  }
  padding-left: ${({ isPickedFound }) => (isPickedFound ? '24px' : '12px')};
  background: ${({ isActive, bgColor }) => (isActive ? bgColor : '#fff')};
`;

const CaretStyled = styled.span`
  display: flex;
  transform: ${({ isRotate }) => (isRotate ? 'rotate(90deg)' : 'none')};
  transition: all 0.3s ease-in-out;
  path {
    fill: ${({ isActive, isPickedFound, color }) =>
      isActive || isPickedFound ? color : '#2B313D'};
  }
`;

const FundChildrenItems = styled.div`
  display: ${({ isMultipleItems }) => (isMultipleItems ? 'flex' : 'grid')};
  /* padding-bottom: ${({ isMultipleItems }) => (isMultipleItems ? '4px' : 0)}; */
  grid-template-columns: repeat(2, minmax(0, 1fr));
  //border-bottom: 1px solid #cdd4df;
  // position: relative;

  position: sticky;
  top: 0;

  z-index: ${({ isHeader }) => (isHeader ? '9' : '8')};

  .delete-btn {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    align-items: center;
    cursor: pointer;
    width: 30px;
    display: flex;
    justify-content: center;
    border-right: 1px solid #cdd4df;
    font-weight: 600;
    font-size: 13px;
  }
`;

const SheetStyled = styled.span`
  display: flex;
  path {
    stroke: ${({ isActive, color }) => (isActive ? color : '#2B313D')};
  }
`;

const FundName = styled.div`
  gap: 6px;
  display: flex;
  align-items: center;
  p {
    color: #2b313d;
    font-size: 12px;
    font-weight: 600;
  }
`;

const Body = styled.div``;

const Tab = styled.div`
  cursor: pointer;
  padding: 8px;
  border: 1px solid #cdd4df;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #2b313d;
  background-color: ${({ isActive }) => (isActive ? 'rgba(61, 59, 255, 0.20)' : '#fff')};
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  span {
    color: #5c5d61;
    font-size: 12px;
    font-weight: 500;
    display: block;
  }
`;

const Menu = styled.div`
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #7888f5;
  overflow: hidden;
  padding: 8px;
  box-shadow:
    0px 171px 48px 0px rgba(0, 0, 0, 0),
    0px 110px 44px 0px rgba(0, 0, 0, 0.01),
    0px 62px 37px 0px rgba(0, 0, 0, 0.05),
    0px 27px 27px 0px rgba(0, 0, 0, 0.09),
    0px 7px 15px 0px rgba(0, 0, 0, 0.1);
  .title {
    padding: 6px 12px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e2e2e2;
    gap: 5px;
    color: #5c5d61;
    font-size: 14px;
    font-weight: 400;
    width: 136px;
  }

  .prompt {
    margin-bottom: 8px;
    position: relative;
    background: rgba(180, 192, 204, 0.15);
    border-radius: 6px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      height: 1px;
      width: 100%;
      background-color: #cdd4df;
      top: calc(100% + 4px);
      left: 0;
    }

    .buttons {
      display: flex;
      align-items: center;
      position: absolute;
      top: calc(50% - 9px);
      right: 5px;
      .edit-btn {
        svg {
          path {
            stroke: #757575;
          }
        }
      }
      button {
        padding: 0;
        border: none;
        display: flex;
        svg {
          width: 16px;
          height: 16px;
        }
      }
    }
    input {
      max-width: 80%;
      padding: 6px 8px;
      border-radius: 6px;
      background: transparent;
      font-size: 12px;
      border: none;
      outline: none;
      &::placeholder {
        color: #9ca3af;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }

  .option {
    padding: 6px 12px;
    display: flex;
    align-items: center;
    gap: 5px;
    color: #5c5d61;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      background: #f3f3ff;
    }
    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

const ExpandAllContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #cdd4df;
  border-bottom: 1px solid #cdd4df;
  background: #f3f3ff;
  padding: 4.5px 12px;

  .title {
    color: #2b313d;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .actions {
    display: flex;
    align-items: center;

    button {
      background-color: transparent;
      cursor: pointer;
      border: none;
      outline: none;
      display: flex;
      align-items: center;

      &.custom-table {
        color: #7888f5;
        font-weight: 600;
        font-size: 12px;

        svg {
          path {
            stroke: #7888f5;
          }
        }
      }

      .right-icon {
        svg {
          transform: scale(0.55);
        }
      }

      svg {
        width: 20px;
        height: 20px;
      }

      &.select-toggler {
        svg {
          width: 16px;
          height: 16px;
        }
      }

      .checked {
        path {
          fill: #7888f5;
        }
      }
    }
  }
`;

export {
  Wrapper,
  Header,
  StructedTableList,
  StructedTableItem,
  Category,
  TableStyle,
  StructedTableCard,
  FundChildrenContainer,
  FundContainer,
  FundChildrenDataValues,
  ColumnValue,
  FundChildrenData,
  FundChildrenDataLabel,
  TableName,
  Fund,
  CaretStyled,
  FundChildrenItems,
  SheetStyled,
  FundName,
  Body,
  Tab,
  Flex,
  Menu,
  ExpandAllContainer
};
